import { render, staticRenderFns } from "./bullCalfProposedForCulling.vue?vue&type=template&id=5b457f79&scoped=true&"
import script from "./bullCalfProposedForCulling.vue?vue&type=script&lang=js&"
export * from "./bullCalfProposedForCulling.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b457f79",
  null
  
)

export default component.exports